// = Libs =
import { FC } from 'react';
import { IconProps } from '@/common/components/icons/icon.types';

// = Constants =
import COLORS from '@/constants/colors';

const DropdownIcon: FC<IconProps> = ({ color = 'dark' }) => {
  const iconColor = COLORS[color];

  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.83845 12.8383C7.44793 12.4477 7.44793 11.8146 7.83845 11.424L8.18751 11.075C8.57774 10.6848 9.2103 10.6844 9.60095 11.0742L14.6313 16.0937L19.6617 11.0742C20.0524 10.6844 20.685 10.6848 21.0752 11.075L21.4242 11.424C21.8148 11.8146 21.8148 12.4477 21.4242 12.8383L14.6313 19.6312L7.83845 12.8383Z"
        fill={iconColor}
      />
      <mask id="mask0" maskUnits="userSpaceOnUse" x="7" y="10" width="15" height="10">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.83845 12.8383C7.44793 12.4477 7.44793 11.8146 7.83845 11.424L8.18751 11.075C8.57774 10.6848 9.2103 10.6844 9.60095 11.0742L14.6313 16.0937L19.6617 11.0742C20.0524 10.6844 20.685 10.6848 21.0752 11.075L21.4242 11.424C21.8148 11.8146 21.8148 12.4477 21.4242 12.8383L14.6313 19.6312L7.83845 12.8383Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <rect width="30" height="30" fill={iconColor} />
      </g>
    </svg>
  );
};

export default DropdownIcon;
